import script from "./PortfolioSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioSection.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioSection.vue?vue&type=style&index=0&id=bd425368&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd425368"]])

export default __exports__